import React from 'react'
import { Switch, Route, HashRouter, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import MainPage from './pages/main'
import LoginPage from './pages/login'
import CreateRootPage from './pages/login/createRoot'
import { Loading } from './components'
import api, { apiAction } from './api'

const checkInterval = 60 * 1000 // every minute

const redirectToLogin = history => {
  const backTo = history.location.pathname.includes('login') ? (
    history.location.search ? history.location.search : ''
  ) : (
    history.location.pathname === '/' ? '' : `?backTo=${history.location.pathname}`
  )
  history.replace(`/login${backTo}`)
}

class App extends React.Component {

  state = {
    loginChecked: false,
    hasRoot: true,
  }

  async componentDidMount() {
    const { history, checkLogin, checkRoot } = this.props
    try {
      const { hasRoot } = await checkRoot()
      if (hasRoot) {
        await checkLogin()
      } else {
        this.setState({
          hasRoot: false,
        })
        return history.replace('/createRoot')
      }
    } catch(e) {
      redirectToLogin(history)
    }

    this.setState({
      loginChecked: true,
    })

    setInterval(async () => {
      if (!this.props.sessionExpired) {
        try {
          await checkLogin()
        } catch(e) {
          // do nothing
        }
      }
    }, checkInterval)
  }

  render() {
    if (!this.state.hasRoot) {
      return (
        <HashRouter>
          <Switch>
            <Route path="/createRoot" component={CreateRootPage}/>
          </Switch>
        </HashRouter>
      )
    }

    if (!this.state.loginChecked) {
      return <Loading overlay/>
    }

    return (
      <HashRouter>
        <Switch>
          <Route path="/login" component={LoginPage}/>
          <Route path="/:page" component={MainPage}/>
          <Redirect to="/recipes"/>
        </Switch>
      </HashRouter>
    )
  }
}


const mapStateToProps = state => ({
  sessionExpired: state.session.expired,
})

const mapDispatchToProps = dispatch => ({
  checkLogin: () => dispatch(apiAction(api.getSessionStatus)(null, { quite: true })),
  checkRoot: () => dispatch(apiAction(api.hasRoot)(null, { quite: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
